import React, { Component } from "react";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {
  isMobile,
  rootUrl,
  appUrl,
  EXPERTS_ROUTES,
  getItemLink,
  imageUrl,
} from "../helpers/ApplicationHelper";
import { browserHistory } from "react-router";
import HomePageData from "../constants/homepage";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import CalendlyHelper from "lib/calendly";
import { connect } from "react-redux";
import GA from "lib/ga";

class Hamburger extends Component {
  constructor(props) {
    super(props);

    this.state = {
      drawerOpen: false,
      exploreOpen: true,
    };

    this.toggleShow = this.toggleShow.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
  }

  componentDidMount() {
    CalendlyHelper.loadCalendly();
  }

  componentWillUnmount() {
    CalendlyHelper.removeCalendly();
  }

  toggleShow() {
    this.toggleFixedBody(true);
    this.setState({ drawerOpen: !this.state.drawerOpen });
  }

  onClickAway() {
    const hamburgerElement = event.target.closest(".hamburger");

    if (!hamburgerElement) {
      this.toggleFixedBody();
      this.setState({ drawerOpen: false });
    }
  }

  renderIcon() {
    return (
      <div className={"icon"} onClick={this.toggleShow}>
        {[1, 2, 3].map((key) => (
          <div
            className={`strip ${this.state.drawerOpen ? "gray" : ""} `}
            key={key}
          />
        ))}
      </div>
    );
  }

  renderSubLinks(subItems) {
    return (
        <List className={`explore-submenu ${this.state.exploreOpen ? 'opened' : null}`}>
          {subItems.map((subTab, subIdx) => {
            const { title, to, beta } = subTab;
            return (
                <React.Fragment key={subIdx}>
                  <ListItem
                      button
                      component="a"
                      key={subIdx}
                      classes={{ root: "list-item" }}
                      className="hamburger-sub-list-item"
                      href={to}
                  >
                    <ListItemText
                        primary={title}
                        classes={{ primary: "list-item-text" }}
                        key={subIdx}
                        onClick={() => {
                          let camelcaseTitle = title.replace(/\W+(.)/g, function(match, chr) {
                            return chr.toUpperCase();
                          }).replace(/\s/g, '');
                          GA.expertsHeaderLinks(camelcaseTitle);
                        }}
                    />
                    {beta ? (
                        <span className="beta-wrapper">
                          <span className="beta-tag">Beta</span>
                      </span>
                    ) : null}
                  </ListItem>
                </React.Fragment>
            );
          })}
        </List>
    );
  }

  renderDropdown(tab) {
    const { title, to } = tab;

    return (
        <React.Fragment key="wrapper-dropdown">
          <ListItem
              button
              component="a"
              key="dropdown-menu-item"
              classes={{ root: "list-item" }}
              href={to}
              onClick={() => {
                this.setState({ exploreOpen: !this.state.exploreOpen, drawerOpen: true });
              }}
          >
            <ListItemText
                primary={title}
                classes={{ primary: "list-item-text" }}
                key="dropdown-menu-item-text"
            />

            <img className={`explore-icon ${this.state.exploreOpen ? 'opened' : ''}`} src={imageUrl("icons/arrow_v4.svg")}  alt='explore'/>
          </ListItem>

          <Divider classes={{ root: "divider" }} />

          {this.renderSubLinks(tab.subCategories)}
        </React.Fragment>
    )
  }

  renderExpertsHamburger(tab, idx) {
    const { to, rootLink, title, type, beta } = tab;
    let link = to || rootLink;

    if(type === "dropdown") return this.renderDropdown(tab);

    if (
      link && link.includes("refer_a_friend") &&
      this.props.ADO && this.props.ADO.user
    ) {
      const user = this.props.ADO.user;
      link = link.replace("{leadId}", user.lead_id).replace("{userId}", user.id);
    }

    return (
        <React.Fragment key={idx}>
          <ListItem
              button
              component="a"
              key={idx}
              classes={{ root: "list-item" }}
              href={link}
          >
            <ListItemText
                primary={title}
                classes={{ primary: "list-item-text" }}
                key={idx}
                onClick={() => {
                  let camelcaseTitle = title.replace(/\W+(.)/g, function(match, chr) {
                    return chr.toUpperCase();
                  }).replace(/\s/g, '');
                  GA.expertsHeaderLinks(camelcaseTitle);
                }}
            />
            {beta ? (
                <span className="beta-wrapper">
                  <span className="beta-tag">Beta</span>
                </span>
            ) : null}
          </ListItem>
          <Divider classes={{ root: "divider" }} />
        </React.Fragment>
    );

  }

  renderDrawer() {
    const expertsRoute = EXPERTS_ROUTES.some(
      (route) => this.props.path && this.props.path.includes(route)
    );
    let isLoggedIn = this.props.Session && this.props.Session.isLoggedIn;
    let menuTabs = expertsRoute
      ? HomePageData.expertsHamburger
      : HomePageData.hamburger.filter(
          (t) => !t.hasOwnProperty("login") || t.login === isLoggedIn
        );

    const list = (
      <>
        <div className='menu-header-v4'>
          <div className='logo-link-v4'>
            <a href={rootUrl()}
               onClick={(e) => {
                 if (expertsRoute) {
                   e.preventDefault()
                   this.toggleShow()
                   browserHistory.push("/learn")
                 } else {
                   e.preventDefault()
                   window.location.href = rootUrl();
                 }
               }}
            >
                <img src={imageUrl(`worthy_logo_white.svg`)} alt="worthy-logo"></img>
            </a>
          </div>

          <div className='menu-close-button'>
            <img src={imageUrl(`icons/close_v4.svg`)} alt="close" onClick={this.toggleShow.bind(this)}></img>
          </div>
        </div>

        <List>
          {menuTabs.map((tab, idx) => {
            return this.renderExpertsHamburger(tab, idx);
          })}
        </List>

        <div className="contact_us">
          <h3>Contact Us</h3>
          <div className="contact_ways">
            <a href="tel:+18882220208">1 (888) 222-0208</a> or <a href="mailto:info@worthy.com">by Email</a>
          </div>
          <h3>Headquarters</h3>
          <div className="address_line">
            25 West 45th St., 2nd Floor,
            <br />
            New York, NY 10036
          </div>
        </div>
      </>
    );

    const clickAwayListener = (
      <ClickAwayListener onClickAway={this.onClickAway}>
        {list}
      </ClickAwayListener>
    );

    return (
      <Drawer
        anchor='right'
        className={"hamburger-drawer"}
        open={this.state.drawerOpen}
        transitionDuration={500}
        classes={{
          paperAnchorLeft: "hamburger-paper-left",
          primary: "",
        }}
      >
        {clickAwayListener}
      </Drawer>
    );
  }

  toggleFixedBody(hamburgerButton) {
    if (
      (isMobile() && event instanceof MouseEvent && !hamburgerButton) ||
      (!isMobile() && event instanceof TouchEvent && !hamburgerButton)
    )
      return;

    if (!this.state.drawerOpen) {
      document.querySelector("body").className += " fixed";
    } else {
      document.querySelector("body").classList.remove("fixed");
    }
  }

  render() {
    const icon = this.renderIcon();
    const drawer = this.renderDrawer();
    return (
      <div className={"hamburger"}>
        {icon}
        {drawer}
      </div>
    );
  }
}

const mapStateToProps = ({ Session, ADO, LastItem }) => {
  return {
    Session,
    ADO,
    LastItem,
  };
};

export default connect(mapStateToProps)(Hamburger);
